import React from "react";
import { Box, Image, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { BASE_GATEWAY_URI } from "../constants";

const NFTCard = ({ token }) => (
  <Link to={`/nft/${token.id}`}>
    <Box
      maxW="sm"
      borderWidth={2}
      borderColor="gray.600"
      // boxShadow="xl"
      borderRadius="lg"
      overflow="hidden"
    >
      <Image src={`${BASE_GATEWAY_URI}${token.image.replace("ipfs://", "")}`} />
      <Box p={6}>
        <Text fontSize="xl" fontWeight="bold">
          {token.title}
        </Text>

        <Text fontSize="md" mt={0.6} color="gray.300">
          {token.description}
        </Text>

        <Text mt={4} fontSize={"sm"}>
          Created By: {token.creator}
        </Text>
      </Box>
    </Box>
  </Link>
);

export default NFTCard;
